export default __webpack_public_path__ + "static/media/imgDocument.14601aab.png";